// displays an error message
import {DownloadFormControler} from '../Downloads/DownloadForm';
import {getCookie} from '../Functions/Utilities';

export function consentMissing(display, consentError) {
  if (display) {
    consentError.classList.remove('hidden');
  } else {
    consentError.classList.add('hidden');
  }
}

export function loadScript(key, language) {
  let script = document.createElement('script');
  script.async = true;
  script.defer = true;
  script.src = 'https://maps.googleapis.com/maps/api/js?sensor=false&callback=getMap&key=' + key + '&language=' + language;
  document.head.appendChild(script);
}

export function CheckConsentForVimeoDownload() {
  const downloadVimeo = document.querySelectorAll('.js-download-usercentrics');
  if (document.querySelector('.js-product-usercentrics') || document.querySelector('.js-slnr-downloads')) {

    waitForUsercentrics(
      () => {
        const isUsercentricsAvailable = document.querySelector('.js-product-usercentrics') || document.querySelector('.js-dc-usercentrics');
        let consent;
        if (isUsercentricsAvailable) {
          consent = window.UC_UI.getServicesBaseInfo().find(data => (data.id === 'HyEX5Nidi-m')).consent.status; // Vimeo Consent ID
          if (!consent) {
            downloadVimeo.forEach(elem => {
              elem.setAttribute('href', '');
              elem.addEventListener('click', e => {
                e.preventDefault();
                if (e.currentTarget instanceof HTMLElement) {
                  let modalID = e.currentTarget.dataset.modalUsercentrics || '';
                  let modal = document.getElementById(modalID);
                  if (modal) {
                    document.body.classList.add('modal-body');
                    modal.classList.add('modal-visible');
                  }
                }
              });
            });
          } else {
            downloadVimeo.forEach(elem => {
              elem.classList.add('js-download-mediaCart');
            });
            if (document.querySelector('.js-product-usercentrics')) {
              new DownloadFormControler();
            }
          }
        }
      });
  }
}

export function waitForUsercentrics(callback: () => any) {
  let counter = 50;

  const doSomething = () => {
    if ((typeof window.UC_UI === 'object' && typeof window.UC_UI.getServicesBaseInfo() === 'object')
    || getCookie('locale') === 'ja' || getCookie('locale') === 'en-us' || getCookie('ipCountry') === 'US') {
      callback();
      return;
    }
    if (counter > 0) {
      counter--;
      window.setTimeout(doSomething, 100);
    }
  };
  doSomething();
}

export function waitForMaps(callback: () => any) {
  let counter = 50;
  const doSomething = () => {
    if (typeof google === 'object' && typeof google.maps === 'object') {
      callback();
      return;
    }
    if (counter > 0) {
      counter--;
      window.setTimeout(doSomething, 100);
    }
  };
  doSomething();
}
